// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import BootstrapVue from 'bootstrap-vue'
import fontawesome from '@fortawesome/fontawesome'
import vuewheel from 'vuewheel'
import solid from '@fortawesome/fontawesome-free-solid'
import brands from '@fortawesome/fontawesome-free-brands'
import Vue2TouchEvents from 'vue2-touch-events'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import App from './App'
import routerConfig from './router'
import './config/i18n'
import store from './config/store'
import VueScrollTo from 'vue-scrollto'
import VueResource from 'vue-resource'
import VueTouch from 'vue-touch'
import VueCookie from 'vue-cookie'
import VueAnalytics from 'vue-analytics'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import Meta from 'vue-meta'

Vue.use(VueScrollTo)
Vue.use(Vue2TouchEvents)
Vue.use(vuewheel)
Vue.use(BootstrapVue)
Vue.use(VueRouter)
Vue.use(VueResource)
Vue.use(VueTouch)
Vue.use(VueCookie)
Vue.use(Loading)
Vue.config.productionTip = false
fontawesome.library.add(brands, solid)
Vue.use(Meta)

Vue.http.options.root = process.env.ROOT_API
Vue.config.lang = VueCookie.get('locale') || 'en'
Vue.i18n.set(Vue.config.lang)

const router = new VueRouter({
  routes: routerConfig,
  mode: 'history'
})

Vue.use(VueAnalytics, {
  id: 'UA-36745618-1',
  router
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App, Loading },
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js